<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YanBian`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.63158 16.5H2L12 7L22 16.5H19.3684M4.63158 16.5L7.44591 13.8264M4.63158 16.5V17.5M19.3684 16.5L16.5541 13.8264M19.3684 16.5V17.5M7.44591 13.8264L12 9.5L16.5541 13.8264M7.44591 13.8264H16.5541" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconYanBian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
